import { useQuery } from '@tanstack/react-query'
import { getStaffAvailability } from '../services/bookingsService'
import { createDayRange } from '../utils/dateTime'
import type { BookingBusinessInfo, BookingService, BookingStaffMember } from '../types/bookings'

interface UseAvailabilityParams {
  selectedDate: Date | null
  selectedService: BookingService | null
  selectedStaff: BookingStaffMember | null
  eligibleStaff: BookingStaffMember[]
  timeZone: string
  businessInfo: BookingBusinessInfo | null
  businessInfoReady: boolean
}

export function useAvailability(params: UseAvailabilityParams) {
  const staffIds =
    params.selectedStaff != null
      ? [params.selectedStaff.id]
      : params.eligibleStaff.map((staff) => staff.id)

  const query = useQuery({
    queryKey: [
      'availability',
      params.selectedDate?.toISOString(),
      params.selectedService?.id,
      staffIds.join(','),
      params.timeZone,
      params.businessInfo?.timeZone ?? null,
    ],
    queryFn: () =>
      getStaffAvailability(
        {
          staffIds,
          ...createDayRange(params.selectedDate as Date, params.timeZone),
        },
        params.selectedService as BookingService,
        params.eligibleStaff,
        params.businessInfo,
        params.selectedStaff?.id,
      ),
    enabled:
      Boolean(params.selectedDate) &&
      Boolean(params.selectedService) &&
      staffIds.length > 0 &&
      params.businessInfoReady,
      staleTime: 0,
  })

  return query
}
